import { createReducer } from '@topconagriculture/frontend-utils';

import { BinControlUnit } from './binControl.types';
import {
  createBinControlUnit,
  deleteBinControlUnit,
  editBinControlUnit,
  getBinControlunitsList,
} from './binControl.actions';

export type BinControlState = BinControlUnit[];

const binControlInitialState: BinControlState = [];

const binControlReducer = createReducer(binControlInitialState, {
  [getBinControlunitsList.done.type]: (state, action: ReturnType<typeof getBinControlunitsList.done>) =>
    action.payload.result,
  [createBinControlUnit.done.type]: (state, action: ReturnType<typeof createBinControlUnit.done>) => [
    ...state,
    action.payload.result,
  ],
  [editBinControlUnit.done.type]: (state, action: ReturnType<typeof editBinControlUnit.done>) => {
    const updatedBinControl = action.payload.result;
    return state.map((binControl) => (binControl.id === updatedBinControl.id ? updatedBinControl : binControl));
  },
  [deleteBinControlUnit.done.type]: (state, action: ReturnType<typeof getBinControlunitsList.done>) =>
    state.filter((binControlUnit) => binControlUnit.id !== action.payload.params),
});

export default binControlReducer;
